<template>
    <file-uploader
            ref="fileUploader"
            bucket="ncrypt-main-storage"
            :dropzoneOptions="dropzoneOptions"
            :addFileText="$t('ncrypt.attachments.add_attachments')"
    />
</template>

<script>
    import FileUploader from "./FileUploader";
    import tippy from 'tippy.js';
    import 'tippy.js/dist/tippy.css';
    import 'tippy.js/dist/svg-arrow.css';
    import 'tippy.js/animations/shift-toward-subtle.css';
    import {roundArrow} from 'tippy.js';

    export default {
        name: "uploadAttachment",
        components: {FileUploader},
        data() {
            return {};
        },
        computed: {
            dropzoneOptions() {
                return {
                    maxFiles: 4,
                    maxFilesize: this.maxFileSize,
                    dictFileTooBig: this.$t('ncrypt.errors.attachment_file_too_big'),
                    dictInvalidFileType: this.$t('ncrypt.errors.attachment_file_type_invalid'),
                    dictUploadCanceled: this.$t('ncrypt.errors.attachment_upload_cancelled'),
                    dictMaxFilesExceeded: this.$t('ncrypt.errors.attachment_max_files_exceeded'),
                }
            },
            maxFileSize() {
                return this.$store.getters.maxAttachmentSize;
            },
            maxFileSizeMessage() {
                let message = '';

                if (!this.$store.getters.licenseType) {
                    message += this.$t('ncrypt.attachments.max_file_size_free_account');
                } else {
                    message += this.$t('ncrypt.attachments.max_file_size_paid_account');
                }

                message += `<br/><br/>`;
                message += this.$t('ncrypt.contact_need_more').replace('{contact}', `<a href="mailto:info@ncrypt.nl">${this.$t('ncrypt.contact')}</a>`);

                return message
                    .replace('{filesize}', this.maxFileSize)
            },
        },
        methods: {
            isValid() {
                return this.$refs.fileUploader.isValid();
            },
            async processQueue(messageId) {
                const finishedUrl = `${this.$store.getters.api_url}/attachments/${messageId}/uploaded`;

                const tags = [
                    {Key: 'message-id', Value: messageId},
                ];

                return await this.$refs.fileUploader.processQueue(finishedUrl, tags);
            },
        },
        mounted() {
            this.$nextTick(async () => {
                if (this.$root.isMobileOrSmall) {
                    return;
                }
                tippy('.dropzone', {
                    content: this.maxFileSizeMessage,
                    placement: 'right',
                    arrow: roundArrow,
                    interactive: true,
                    appendTo: document.body,
                    animation: 'shift-toward-subtle',
                });
            });
        },
    }
</script>

